import cn from '@/utils/cn'
import IconSortingDown from '@/components/Atoms/Icons/IconSortingDown'
import IconSortingUp from '@/components/Atoms/Icons/IconSortingUp'
import IconSortingDouble from '@/components/Atoms/Icons/IconSortingDouble'
import IconDtp2 from '@/components/Atoms/Icons/IconDTPTwo'
import IconDtp3 from '@/components/Atoms/Icons/IconDtpThree'
import IconList from '@/components/Atoms/Icons/IconList'
import ConnectionStatus from './ConnectionStatus/ConnectionStatus'
import Box from '@mui/material/Box'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import dayjs from 'dayjs'
import * as React from 'react'
import { FC } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import IconDtp4 from '@/components/Atoms/Icons/IconDtpFour'
import IconDtp5 from '@/components/Atoms/Icons/IconDtpFive'
import ErrorStatusIcon from './ErrorStatusIcon/ErrorStatusIcon'
const s = cn('devices-list')

type SeverityTypeId = 1 | 2 | 3

const SEVERITY_TEXT: Record<SeverityTypeId, string> = {
  1: 'Смертельное',
  2: 'С пострадавшими',
  3: 'Без пострадавших',
}

export type DetectorUnit = {
  address: string
  id: number
  name: string
  smart: boolean
  type: string
  typeId: number
  sameDirectionTraffic: number
  oncomingTraffic: number
  totalTraffic: number
  errorMessage: any
  connectionStatus: any
  lastPackageDate: any
  state?: number
}

interface Props {
  unit: DetectorUnit
}

const TableViewDetector: FC<Props> = ({ unit }) => {
  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        // to={`${unit.id}`}
        component='tr'
        // component={Link}
        className={s()}
        sx={{ textDecoration: 'none' }}
        // onClick={() => navigate(`${unit.id}`)}
      >
        <TableCell
          component='th'
          scope='row'
          width={'100%'}
        >
          <Box
            display='flex'
            alignItems='end'
            gap={1}
          >
            <Link
              to={`${unit.id}`}
              className={s('link')}
            >
              <span
                className={s('name')}
                style={{ color: 'gray' }}
              >
                {unit.name}
              </span>
              <span
                className={s('address')}
                style={{ color: '#0072BC' }}
              >
                {unit.address}
              </span>
            </Link>
          </Box>
        </TableCell>

        <TableCell
          align='right'
          sx={{
            color: '#0072BC',
            cursor: 'pointer',
          }}
        >
          <ErrorStatusIcon
            errorMessage={unit?.errorMessage}
            state={unit?.state}
          />
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
              gap: '25px',
            }}
          >
            <Tooltip
              title={'Попутное движение'}
              placement='top'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                justifyContent='start'
              >
                <IconSortingDown />
                <span style={{ whiteSpace: 'nowrap' }}>
                  {unit.sameDirectionTraffic}
                </span>
              </Box>
            </Tooltip>
            <Tooltip
              title={'Встречное движение'}
              placement='top'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                justifyContent='start'
              >
                <IconSortingUp />{' '}
                <span style={{ whiteSpace: 'nowrap' }}>
                  {unit.oncomingTraffic}
                </span>
              </Box>
            </Tooltip>
            <Tooltip
              title={'Всего'}
              placement='top'
            >
              <Box
                display='flex'
                gap={1}
                alignItems='center'
                justifyContent='start'
              >
                <IconSortingDouble />{' '}
                <span style={{ whiteSpace: 'nowrap' }}>
                  {unit.totalTraffic}
                </span>
              </Box>
            </Tooltip>
            <ConnectionStatus
              connectionStatus={unit?.connectionStatus}
              lastPackageDate={unit?.lastPackageDate}
            />
          </Box>
        </TableCell>
      </TableRow>
    </>
  )
}

export default TableViewDetector
